<template>
    <v-layout row wrap>
        <v-flex class="resources inner-scrollbar">
           
                <v-expansion-panel v-click-outside="none" v-model="menuPanel">
                    <v-expansion-panel-content v-for="(heading, index1) in formattedList.menu" :key="heading.title" v-if="verifyTitle(heading.title)">
                        <div 
                            slot="header"
                            class="heading"
                            :id="heading.title"
                            @click="toggle" 
                            v-if="heading.title && heading.title !== myToolsConstants.My_ACCOUNT && heading.title !== myToolsConstants.SHARE_YOUR_IDEAS"
                            :data-qe-id="'resourcesMenu_'+index1">{{heading.title}}</div>
                        <v-card v-for="(subheading,index2) in heading.submenu.filter(l => !FORUM_LINKS_REMOVED.includes(l.title))" :key="subheading.title">
                            <a class="urls" id="cff_unitTest" v-if="subheading.title && subheading.title.toLowerCase() === SpeakerApplicants.FIND_A_CFF.toLowerCase()" @click="openCFFDirectory" :data-qe-id="'resourcesMenu_'+index1+'_'+index2">{{subheading.title}} </a>
                            <a class="urls" v-else-if="subheading.title" :href="subheading.navigationUrl" :target="linkTarget(subheading.navigationUrl)" @click="showHideTools()" :data-qe-id="'resourcesMenu_'+index1+'_'+index2">{{subheading.title}} </a>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-flex class="left-heading"> {{myToolsConstants.FOLLOW_YPO_AT}} </v-flex>
                <v-flex>
                    <v-flex class="resources-social">
                        <span v-for="heading in followYpoAt" :key="heading.title">
                            <a :href="heading.navigationUrl" :title="heading.title" v-if="heading.title ==myToolsConstants.FACEBOOK" target="_blank" data-qe-id="facebookLink"><i class="fab fa-facebook"></i></a>
                            <a :href="heading.navigationUrl" :title="heading.title" v-if="heading.title ==myToolsConstants.LINKEDIN" target="_blank" data-qe-id="linkedInLink"><i class="fab fa-linkedin"></i></a>
                            <a :href="heading.navigationUrl" :title="heading.title" v-if="heading.title ==myToolsConstants.INSTAGRAM" target="_blank" data-qe-id="instragramLink"><i class="fab fa-instagram"></i></a>
                            <a :href="heading.navigationUrl" :title="heading.title" v-if="heading.title ==myToolsConstants.TWITTER" target="_blank" data-qe-id="twitterLink"><i class="fab fa-twitter-square"></i></a>
                            <a :href="heading.navigationUrl" :title="heading.title" v-if="heading.title ==myToolsConstants.YOUTUBE" target="_blank" data-qe-id="youtubeLink"><i class="fab fa-youtube-square"></i></a>
                        </span>
                    </v-flex>
                    <v-flex class="resources-social__single">
                        <a :href="socialLinks.navigationUrl" target="_blank" data-qe-id="socialGuidelinesLink">{{socialLinks.title}}</a>
                    </v-flex>
                </v-flex>
           
        </v-flex>
    </v-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { storeAction } from "../../store/storeActions.constant";
import { storeGetters } from '../../store/storeGetters.constant';
import { myToolsConstants } from "./mytools.constant.js";
import ClickOutside from "vue-click-outside";
import { SpeakerApplicants } from "../Speakers/speakerConstant";
import { FORUM_LINKS_REMOVED } from "../ForumPage/ForumConstants";

export default {
    name: "Resources",
    data: () => ({
        myToolsConstants,
        menuPanel: [],
        subMenuPanel: [],
        formattedList: {
            title: 'Resources',
            menu: [],
        },
        myYpoLinks: [],
        followYpoAt: [],
        socialLinks: [],
        SpeakerApplicants,
        FORUM_LINKS_REMOVED,
    }),
    props: {
        showHideTools: {
            type: Function,
        },
     },
    created() {
        this.getResourceLinks();
    },
    components: {},
    methods: {
        ...mapActions({
            getResourceLinks: `tools/${storeAction.getResourceLinks}`,
        }),
        openCFFDirectory() {
            this.showHideTools();
            this.$router.push({
                path: `/speakerPage/SearchSpeakers`,
                query: {
                    speakersWhoAre: this.SpeakerApplicants.IS_CFF_SPEAKER,
                },
            });
        },
        none() {
            this.subMenuPanel = -1;
            this.menuPanel = -1;
        },
        toggle() {
            this.subMenuPanel = -1;
        },
        formatData(data) {
            if (data) {
                data.forEach((item, i) => {
                    const { resourceCenterCategoryName } = (item[0] || {});
                    this.formattedList.menu[i] = {
                        title: '',
                        submenu: [],
                    };
                    this.formattedList.menu[i].title = resourceCenterCategoryName;
                    item.forEach((itm) => {
                        this.formattedList.menu[i].submenu.push({
                            title: itm.name,
                            navigationUrl: itm.url,
                        });
                    });
                    if (resourceCenterCategoryName === myToolsConstants.FOLLOW_YPO_AT) {
                        this.followYpoAt = this.formattedList.menu[i].submenu;
                    }
                });
            }
            this.setSocialLinks();
        },
        setSocialLinks() {
            this.followYpoAt.forEach((item) => {
                if (item.title === myToolsConstants.SOCIAL_MEDIA_GUIDELINES) {
                    this.socialLinks = item;
                }
            });
        },
        verifyTitle(data) {
            if (data !== myToolsConstants.FOLLOW_YPO_AT) {
                return true;
            }
        },
        linkTarget(url) {
            let target = '_self';
            if (url && !url.includes('http')) {
                url = `http://${url}`;
            }

            const appOrigin = window.location.origin;
            if (url.includes(appOrigin) || this.isMobileAppBrowser) {
                target = '_self';
            } else {
                target = '_blank';
            }
            return target;
        },
    },
    directives: {
        ClickOutside,
    },
    computed: {
        ...mapGetters({
            resourceLinks: `tools/${storeGetters.resourceLinks}`,
            isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
        }),
        
    },
    watch: {
        resourceLinks(data) {
            this.formatData(data);
        },
    },
};
</script>

<style lang="scss">
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";

    .resources {
    border: none;

    .left-heading {
        padding: 20px 0 20px 20px;
        color: $ypo-cta;
        font-size: 14px;
        font-weight: bold;
        line-height: 14px;
        background: $white;
        border-top: 1px solid $ypo-extra-light-gray;
        text-align: left;
    }

    &-social {
        text-align: center;
        background:$white;
        padding-bottom: 10px;

        span {
            display: inline-block;
            margin: 0 13px;
            font-size: 24px;

            a {
                color: $ypo_blue;
                transition: 0.2s;

                &:hover {
                    color: $ypo-cta;
                }
            }
        }

        &__single {
            text-align: center;
            background: $white;
            padding: 5px 0 15px 0;

            a {
                color: $ypo-cta;
                font-size: 12px;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }

    .heading {
        color: $ypo-cta;
        font-size: 14px;
        font-weight: bold;
        line-height: 18px;
    }

    .urls {
        text-decoration: none;
        transition: 0.3s;
        font-size: 14px;
        font-weight: 500;
        color: $ypo-cta;
        margin-top: 15px;
        display: inline-block;
        margin-left: 20px;

        &:hover {
            text-decoration: underline;
            color: $ypo_blue;
        }
    }

    &__list {
        &:first-child {
            padding-top: 20px;
        }
    }

    .v-expansion-panel {
        box-shadow: none;
        &__container {
            border-top: 1px solid $ypo-extra-light-gray !important;
            &__main {
                position: relative;
                transition: 2s;
                
                &:hover {
                    background: $ypo-extra-light-gray;
                }
            }

            .v-expansion-panel__header {
                padding: 10px 15px;
                min-height: inherit;
                position: relative;
                background: $white;
            }

            &--active {
                background: $ypo-extra-light-gray;
                position: relative;

                &.url-links {
                    padding: 5px 30px 10px 30px;
                    background: transparent;
                }

                .v-expansion-panel__header {
                    background: $white;
                   

                    .heading {
                        color: $ypo_blue;
                    }
                }
                .v-expansion-panel__body {
                    background: rgba($ypo-cta, 0.03);
                    padding-bottom: 20px;
                    .v-card {
                        background: transparent;
                    }
                }
            }
        }
    }
}
</style>
